import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Slider,
  FormControlLabel,
  Switch,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import {
  Delete as DeleteIcon,
  PlayArrow as PlayIcon,
  Pause as PauseIcon,
  Transform as TransformIcon
} from '@mui/icons-material';

const CharacterControls = ({ character, onUpdate, onDelete }) => {
  if (!character) return null;

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        mb: 2 
      }}>
        <Typography variant="subtitle1">
          Character Controls
        </Typography>
        <Box>
          <Tooltip title="Delete Character">
            <IconButton 
              onClick={onDelete}
              size="small"
              sx={{ color: 'error.main' }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Model Type</InputLabel>
        <Select
          value={character.type || 'character'}
          onChange={(e) => onUpdate({ type: e.target.value })}
          label="Model Type"
        >
          <MenuItem value="character">Character</MenuItem>
          <MenuItem value="prop">Prop</MenuItem>
          <MenuItem value="environment">Environment</MenuItem>
        </Select>
      </FormControl>

      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Scale
        </Typography>
        <Slider
          value={character.scale}
          onChange={(e, value) => onUpdate({ scale: value })}
          min={0.1}
          max={2}
          step={0.1}
          marks={[
            { value: 0.1, label: '0.1x' },
            { value: 1, label: '1x' },
            { value: 2, label: '2x' }
          ]}
        />
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Rotation
        </Typography>
        <Slider
          value={character.rotation[1]} // Y-axis rotation
          onChange={(e, value) => onUpdate({ 
            rotation: [
              character.rotation[0],
              value,
              character.rotation[2]
            ] 
          })}
          min={-Math.PI}
          max={Math.PI}
          step={Math.PI / 12}
          marks={[
            { value: -Math.PI, label: '-180°' },
            { value: 0, label: '0°' },
            { value: Math.PI, label: '180°' }
          ]}
        />
      </Box>

      {character.animations?.length > 0 && (
        <>
          <FormControlLabel
            control={
              <Switch
                checked={character.isPlaying}
                onChange={(e) => onUpdate({ isPlaying: e.target.checked })}
              />
            }
            label="Play Animation"
          />

          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Animation Speed
            </Typography>
            <Slider
              value={character.animationSpeed || 1}
              onChange={(e, value) => onUpdate({ animationSpeed: value })}
              min={0.1}
              max={2}
              step={0.1}
              marks={[
                { value: 0.1, label: '0.1x' },
                { value: 1, label: '1x' },
                { value: 2, label: '2x' }
              ]}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default CharacterControls;
